// extracted by mini-css-extract-plugin
module.exports = {"Root":"Select_Root__1KIUU","Label":"Select_Label__yFbCi","SelectContainer":"Select_SelectContainer__E7OXj","Select":"Select_Select__ISAmb","Option":"Select_Option__s_7Fe"};